import React, { useState } from "react";

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationDE from "../../../locale/de/translation.json";
import translationEN from "../../../locale/en/translation.json";
import { IArtikel } from "../../../Models/IArtikel";
import { getHighlightedText } from "../../../Controls/HighlightedText";
import { createTableColumn, Link, Text } from "@fluentui/react-components";
import { StackShim } from "@fluentui/react-migration-v8-v9";

const resources = {
  en: {
    translation: translationEN,
  },
  de: {
    translation: translationDE,
  },
};

// initialize i18next with catalog and language to use
i18n.use(LanguageDetector).init({
  resources,
});

interface IArtikelColumnsProps {
  searchParamArtikelId: string;
  searchParamBenennung: string;
}

export function ArtikelColumns(props: IArtikelColumnsProps) {
  const [showDownloadNotification, setShowDownloadNotification] =
    useState(false);

  const [clickedArtikel, setClickedArtikel] = useState<IArtikel>();

  const columns = [
    // ------------artikelId------------
    createTableColumn<IArtikel>({
      columnId: "artikelId",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("artikelId")}</Text>;
      },
      renderCell: (item) => {
        return (
          <>
            <Link
              onClick={(event: any) => {
                setClickedArtikel(item);
              }}
            >
              {getHighlightedText(
                item.artikelId ? item.artikelId : "",
                props.searchParamArtikelId,
              )}
            </Link>
          </>
        );
      },
    }),
    // ------------benennung------------
    createTableColumn<IArtikel>({
      columnId: "benennungId",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("benennung")}</Text>;
      },
      renderCell: (item) => {
        return (
          <StackShim tokens={{ childrenGap: 5 }}>
            <Text style={{ marginTop: "8px" }}>
              {getHighlightedText(
                item.benennungDE ? item.benennungDE : "",
                props.searchParamBenennung,
              )}
            </Text>
            <Text style={{ marginBottom: "8px" }}>
              {getHighlightedText(
                item.benennungEN ? item.benennungEN : "",
                props.searchParamBenennung,
              )}
            </Text>
          </StackShim>
        );
      },
    }),
    // ------------artikelgruppe------------
    createTableColumn<IArtikel>({
      columnId: "artikelgruppeId",
      renderHeaderCell: () => {
        return <Text> Artikelgruppe</Text>;
      },
      renderCell: (item) => {
        return (
          <Text>
            {i18n.language.includes("de")
              ? item.artikelgruppe?.benennungDE
              : item.artikelgruppe?.benennungEN}
          </Text>
        );
      },
    }),
    // ------------sachgruppe------------
    createTableColumn<IArtikel>({
      columnId: "sachgruppeId",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("sachgruppe")}</Text>;
      },
      renderCell: (item) => {
        return (
          <Text>
            {i18n.language.includes("de")
              ? item.sachgruppe?.benennungDE
              : item.sachgruppe?.benennungEN}
          </Text>
        );
      },
    }),
  ];

  return {
    // addToBedarf: addToBedarf,
    // przArtikelId: przArtikelId,
    // kvmArtikelId: kvmArtikelId,
    // artikelIdFlachabtrieb: artikelIdFlachabtrieb,
    clickedArtikel: clickedArtikel,
    // getColumns: () => getColumns(),
    resetArtikel: () => setClickedArtikel(undefined),
    // resetAddToBedarf: () => setAddToBedarf(undefined),
    // resetPrzArtikelId: () => setPrzArtikelId(undefined),
    // resetKvmArtikelId: () => setKvmArtikelId(undefined),
    showDownloadNotification: showDownloadNotification,
    getColumns: () => {
      return columns;
    },
  };
}
